import http from "../core/http.crm.core";
export class UserService {
  constructor() {}

  async getUserInfo() {
    const { data } = await http.get("/account/info");
    return data;
  }
}
